import type {ColorMap, CSS} from '@pinecast/styles';
import styled from '@pinecast/styles';
import * as React from 'react';

import {DEFAULT_FONT} from './constants';

const style = (_: unknown, designColors: ColorMap) => ({
  backgroundColor: designColors.contentBackground,
  borderBottomLeftRadius: 7,
  borderBottomRightRadius: 7,
  borderTopLeftRadius: 7,
  borderTopRightRadius: 7,
  borderColor: designColors.borderGrayNormal,
  borderStyle: 'solid',
  borderWidth: '1px',
  boxShadow: `0 1px 0 ${designColors.contentBorder}`,
  color: designColors.contentText,
  display: 'flex',
  flexDirection: 'column',
  fontFamily: DEFAULT_FONT,
  fontSize: 'inherit',
  marginTop: 0,
  marginRight: 0,
  marginBottom: 20,
  marginLeft: 0,
  paddingBottom: 20,
  paddingLeft: 20,
  paddingRight: 20,
  paddingTop: 20,
  textAlign: 'left',
  transition: 'box-shadow 0.2s',
  width: '100%',
});

const cardMap = new Map<keyof JSX.IntrinsicElements, React.ComponentType>();
function getCard(
  type: keyof JSX.IntrinsicElements,
): React.ComponentType<{[key: string]: any}> {
  const existing = cardMap.get(type);
  if (existing) {
    return existing;
  }

  const card = styled(type, style) as React.ComponentType<any>;
  cardMap.set(type, card);
  return card;
}

const Card = React.forwardRef(
  (
    {
      children,
      type = 'div',
      ...rest
    }: {
      children: any;
      style?: CSS;
      tabIndex?: number | null;
      type?: keyof JSX.IntrinsicElements;
    } & Omit<React.HTMLProps<HTMLDivElement>, 'style' | 'tabIndex'>,
    ref,
  ) => {
    const Card_ = getCard(type);
    return (
      <Card_ {...rest} ref={ref}>
        {children}
      </Card_>
    );
  },
);

export default Card;
